import cx from 'classnames'
import styles from './Day.module.scss'
import { getSingleArtistCalendarDayClasses } from '../../../../utils'
import { DATE_FORMAT } from '~constants'
import type { CalendarDayEventProps } from '../../../../types'
import { useEventsStore } from 'store/useEventsStore'
import dayjs, { DayjsInput } from 'utils/dayjs'
import { useWindowSize } from '~utils/hooks'

type DayProps = {
  dayInfo: CalendarDayEventProps
  handleDateSelection: (date: DayjsInput) => void
}

export const Day = ({ dayInfo, handleDateSelection }: DayProps) => {
  //Extract selectedDate and setSelectedDate from the events store
  const { selectedDateForSingleArtist: selectedDate } = useEventsStore()
  const { isBreakpoint: isMobile } = useWindowSize('sm', '<')
  const day = dayInfo.date
  const dayKey = day.format(DATE_FORMAT.DATE_TIME)

  //Generate the CSS classes for the day cell
  const cellClasses = getSingleArtistCalendarDayClasses(dayInfo, selectedDate as string, isMobile as boolean)
    .split(' ')
    .map(cls => styles[cls])

  //Check if the day is outside the selected month
  const isOutofSelectedMonth = !dayInfo.date.isSame(dayjs(selectedDate as string), 'month')

  const setSelectedDate = (dayKey: string) => {
    if (isOutofSelectedMonth || dayInfo.isFromBeforeCurrentMonth || dayInfo.isPastDate || dayInfo.events?.length == 0)
      return
    handleDateSelection(dayjs(dayKey, DATE_FORMAT.DATE_TIME))
  }

  return (
    <button key={dayKey} className={cx(cellClasses)} onClick={() => setSelectedDate(dayKey)}>
      {!dayInfo.isFromBeforeCurrentMonth && !isOutofSelectedMonth && (
        <div className={styles['calendar__day-header']}>{day.date()}</div>
      )}
    </button>
  )
}
export default Day
